const _ = require('lodash');
const BaseObject = require('./base_object');
const PAGE_SIZE = 5;

/**
 * @class BaseCollection
 */
class BaseCollection {

     /**
     * @method BaseCollection#find
     * @see http://lodash.com/docs/#find
     */
    find = function(){ return new BaseCollection(_.find.apply(_, [this.items].concat(Array.from(arguments))), this.locale) }
    /**
     * @method BaseCollection#orderBy
     * @see http://lodash.com/docs/#orderBy
     */
    orderBy = function(){ return new BaseCollection(_.orderBy.apply(_, [this.items].concat(Array.from(arguments))), this.locale) }
    /**
     * @method BaseCollection#filter
     * @see http://lodash.com/docs/#filter
     */
    filter = function(){ return new BaseCollection(_.filter.apply(_, [this.items].concat(Array.from(arguments))), this.locale) }
    /**
     * @method BaseCollection#map
     * @see http://lodash.com/docs/#map
     */
    map = function(){ return new BaseCollection(_.map.apply(_, [this.items].concat(Array.from(arguments))), this.locale) }

    static methods = ['find', 'orderBy', 'filter', 'map']
    locale = "en"
    constructor(content, locale) {
        this.locale = locale;
        if (Array.isArray(content)) {
            this.items = content
            this.name = 'Dynamic collection'
        } else if (_.isObject(content) && _.has(content, 'category_values')) {
            this.name = content.name;
            this.id = content.id;
            this.schema = content.schema;
            this.items = content.category_values
        } else if (_.isObject(content)) {
            return new BaseObject(content, this.locale);

        } else {
            throw new Error('Type is not supported')
        }
    }
    getItems() {
        return this.items.map(item => {
            if (_.isObject(item)) {
                let tmpItem = {};
                Object.keys(item).map(key => {
                    // tmpItem[key] = item[key]?.[this.locale] || item[key];

                    if (typeof item[key] === 'string'){
                        tmpItem[key] = item[key];
                    } else {
                        tmpItem[key] = item[key]?.[this.locale]
                    }

                    if (tmpItem[key] === undefined) tmpItem[key] = item[key];
                })
                return tmpItem;
            }
            return item;
        })
    }
    getPaths(pathBy) {
        const mappedItems = this.map(pathBy).getItems();
        const paths = mappedItems.map(item => ({
            params: { [pathBy]: item }
        }))
        return paths;
    }
    getJsonItem(value, getBy) {
        const findResult = this.find(item => item[getBy] === value);
        if(!findResult){
            return null;
        }
        return findResult?.toJson();
    }
    getPages(size = PAGE_SIZE) {
        const numberOfPages = Math.ceil(this.items.length / size);
        const pagesParams = [];
        for (let i = 1; i <= numberOfPages; i++) {
            pagesParams.push({
                params: { page: i.toString() }
            })
        }
        return pagesParams;
    }
    getPageItems(pageNumber, size = PAGE_SIZE) {
        const numberOfPages = Math.ceil(this.items.length / size);
        const intPageNumber = Number(pageNumber);
        const nextPageNumber = intPageNumber >= numberOfPages ? null : intPageNumber + 1;
        const prevPageNumber = intPageNumber <= 1 ? null : intPageNumber - 1;
        const firstItemAtIndex = (intPageNumber - 1) * size;
        const lastItemIndex = ((intPageNumber - 1) * size) + size;
        const itemsByLocale = this.items.slice(firstItemAtIndex, lastItemIndex).map(item => {
            let tmpItem = {};
            Object.keys(item).map(key => {
                tmpItem[key] = item[key]?.[this.locale] || item[key];
            })
            return tmpItem;
        })
        return {
            totalItems: this.items.length,
            totalPages: numberOfPages,
            current: intPageNumber,
            next: nextPageNumber,
            previous: prevPageNumber,
            pageSize: size,
            items: itemsByLocale
        }
    }

    pluck(props=[]) {
        return new BaseCollection(this.items.map(item=>_.pick(item,props)), this.locale);
    }
}

BaseCollection.prototype[Symbol.iterator] = function*() {
    yield* this.items;
};

module.exports = BaseCollection;